module.exports = {
          srcSet: __webpack_public_path__ + "b7452835ae3432d0390518c7de7bb312-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "b7452835ae3432d0390518c7de7bb312-90.png",width: 90,height: 32}],
          src: __webpack_public_path__ + "b7452835ae3432d0390518c7de7bb312-90.png",
          toString:function(){return __webpack_public_path__ + "b7452835ae3432d0390518c7de7bb312-90.png"},
          
          width: 90,
          height: 32
        }